/**
 * Professional Glass Blur Paint Worklet
 * 
 * Simulates advanced back-drop blur and frosted glass effects using
 * procedural fragment shaders behavior (via Paint API).
 * 
 * Note: Real backdrop-blur is handles by CSS, this worklet adds the 
 * "micro-texture" and light scattering that makes it look premium.
 */

class GlassBlur {
  static get inputProperties() {
    return [
      '--fluent-glass-opacity',
      '--fluent-glass-tint',
      '--fluent-glass-reflectivity'
    ];
  }

  paint(ctx: CanvasRenderingContext2D, size: { width: number; height: number }, props: any) {
    const opacity = parseFloat(props.get('--fluent-glass-opacity')) || 0.1;
    const tint = props.get('--fluent-glass-tint').toString() || 'rgba(255, 255, 255, 0.4)';
    const reflectivity = parseFloat(props.get('--fluent-glass-reflectivity')) || 0.5;

    ctx.save();
    
    // 1. Apply base tint
    ctx.fillStyle = tint;
    ctx.globalAlpha = opacity;
    ctx.fillRect(0, 0, size.width, size.height);

    // 2. Add surface reflectivity (subtle diagonal gradient)
    const gradient = ctx.createLinearGradient(0, 0, size.width, size.height);
    gradient.addColorStop(0, `rgba(255, 255, 255, ${reflectivity * 0.2})`);
    gradient.addColorStop(0.5, 'rgba(255, 255, 255, 0)');
    gradient.addColorStop(1, `rgba(255, 255, 255, ${reflectivity * 0.1})`);
    
    ctx.globalAlpha = 1;
    ctx.fillStyle = gradient;
    ctx.fillRect(0, 0, size.width, size.height);

    // 3. Add grain (light scattering)
    for (let i = 0; i < 500; i++) {
        const x = Math.random() * size.width;
        const y = Math.random() * size.height;
        ctx.fillStyle = 'rgba(255, 255, 255, 0.05)';
        ctx.fillRect(x, y, 1, 1);
    }

    ctx.restore();
  }
}

registerPaint('fluent-glass-blur', GlassBlur);
